import React from  "react";


const Preview: React.FC = () => {
  return <p>Preview</p>
};

export default Preview;
